import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function Visualization() {
  return;
}